export enum TenantImageNameEnum {
  homepageImage = "homepageImage",
  carsHomepageImage = "carsHomepageImage",
  activitiesHomepageImage = "activitiesHomepageImage",
  hotelPlaceholder = "hotelPlaceholder",
  packagePlaceholder = "packagePlaceholder",
}
